import React, { useState } from "react";
import "./index.css"; // Ensure CSS is properly linked

function Modal({ show, onClose, onSubmit, formId }) {
  const [fieldType, setFieldType] = useState("");
  const [position, setPosition] = useState("");
  const [label, setLabel] = useState("");
  const [required, setRequired] = useState(false); // ✅ New Required Field
  const [options, setOptions] = useState([""]);

  if (!show) return null;

  const addOption = () => setOptions([...options, ""]);
  const removeOption = (index) => setOptions(options.filter((_, i) => i !== index));
  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const posIndex = position ? parseInt(position, 10) - 1 : null;

    const fieldData = {
      fieldType,
      position: posIndex,
      label,
      required, // ✅ Send Required Status
      options: fieldType === "dropdown" ? options : [],
    };

    const token = localStorage.getItem("token"); // ✅ Retrieve token

    await fetch("https://leadbankapi.gensparc.com/api/fields", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ id: formId, fields: [fieldData] }),
    });

    onSubmit(fieldData);
    setFieldType("");
    setPosition("");
    setLabel("");
    setRequired(false);
    setOptions([""]);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Add Custom Field</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Field Type:</label>
              <select
                value={fieldType}
                onChange={(e) => setFieldType(e.target.value)}
                required
              >
                <option value="">Select Field Type</option>
                <option value="text">Text</option>
                <option value="number">Number</option>
                <option value="dropdown">Dropdown</option>
              </select>
            </div>

            <div className="form-group">
              <label>Position (Optional):</label>
              <input
                type="number"
                min="1"
                placeholder="Enter position (e.g., 1)"
                value={position}
                onChange={(e) => setPosition(e.target.value)}
              />
            </div>

            <div className="form-group" >
              <label>Label:</label>
              <input
                type="text"
                placeholder="Enter Label"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                required
              />
            </div>

            {/* ✅ Required Field Checkbox */}
            <div className="">
              <input
                type="checkbox"
                id="required"
                checked={required}
                onChange={(e) => setRequired(e.target.checked)}
              />
              <label htmlFor="required">Required</label>
            </div>

            {/* ✅ Dropdown Options Section */}
            {fieldType === "dropdown" && (
              <div className="dropdown-options-section">
                <label className="options-label">Option List:</label>
                {options.map((opt, index) => (
                  <div key={index} className="option-row">
                    <input
                      type="text"
                      placeholder={`Option ${index + 1}`}
                      value={opt}
                      onChange={(e) => handleOptionChange(index, e.target.value)}
                    />
                    <button
                      type="button"
                      className="remove-option-btn"
                      onClick={() => removeOption(index)}
                    >
                      &times;
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn add-another-btn"
                  onClick={addOption}
                >
                  + Add Another
                </button>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Modal;
